import 'vanilla-cookieconsent/dist/cookieconsent.css';
import * as CookieConsent from 'vanilla-cookieconsent';

CookieConsent.run({
  guiOptions: {
    consentModal: {
      layout: 'bar inline',
      position: 'bottom',
      equalWeightButtons: true,
    },
  },

  categories: {
    necessary: {
      enabled: true,
      readOnly: true,
    },
    analytics: {
      autoClear: {
        cookies: [
          { name: '_yasc' },
          { name: 'bh' },
          { name: 'i' },
          { name: 'is_gdpr' },
          { name: 'is_gdpr_b' },
          { name: 'yandexuid' },
          { name: 'yashr' },
        ],
        reloadPage: true,
      },
    },
  },

  language: {
    default: 'ru',
    translations: {
      ru: {
        consentModal: {
          title: 'Мы используем cookie-файлы',
          description: 'Этот сайт использует cookie-файлы сервисов Яндекса для аналитики и отображения карт. Вы можете принять или отклонить их использование.',
          acceptAllBtn: 'Принять',
          acceptNecessaryBtn: 'Отклонить',
        },
        preferencesModal: {
          title: 'Настройки cookie',
          acceptAllBtn: 'Принять все',
          acceptNecessaryBtn: 'Отклонить все',
          savePreferencesBtn: 'Сохранить настройки',
          sections: [
            {
              title: 'Обязательные cookie',
              description: 'Технические cookie, необходимые для работы сайта.',
              linkedCategory: 'necessary',
            },
            {
              title: 'Аналитика и карты',
              description: 'Cookie сервисов Яндекс Метрика и Яндекс Карты для сбора статистики и отображения карт.',
              linkedCategory: 'analytics',
            },
          ],
        },
      },
    },
  },
});
